import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner,Input } from 'reactstrap';
import Select from 'react-select';
import { observationSave } from '../../../helpers/backend_helper';
import { getStorageCompany } from '../../../helpers/api_helper';
import {Alert} from '../../../helpers/alerts/alertHelper';
import Validate from './Validate'

const AddObservation = ({modal,setModal,id,authUser}) => {
	const company = getStorageCompany();
	const [routes, setRoutes] = useState([]);
	const [ errors, setErrors ] = useState([]);
	const [ units, setUnits ] = useState([]);
	const [ item, setItem ] = useState({observation: '',
    		operator_id:modal.id});
	const [ loading, setLoading ] = useState(false);
	const handleClose = () => {
		setModal({...modal,show:true,update:false,type:1});
		setItem( {...item,
    		id: 0,
    		observation: '',
    		operator_id:id
    	});	
    }

    const handlerOnChange = (value,name) => {
		setItem({...item, [name]:value});
    }

    const save = async () => {
    	setErrors([])
    	
    	setLoading(true)

		const response =  await observationSave(item)
			setLoading(true)
			modal.function()
			setModal({...modal,show:true,type:1})		
    }

    return (
		<div>
	        <Modal isOpen={modal.show}>
				<ModalHeader className="bg-primary">Agregar observación</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="col-sm-12">
						    <label className="form-label">Observacion:</label>
						    <Input className="form-control" name="observation" placeholder='Observacion' type="textarea" rows='5' onChange={ e => handlerOnChange(e.target.value,'observation') } value={item.observation}/>
						    {
						    	errors && <div className="form-text text-danger">{errors.observation && errors.observation[0]}</div>
						    }
						</div>
					</div>	
				</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={save} disabled={loading}>
						{loading && <Spinner size="sm"></Spinner> } <i className='fa fa-save'></i> Guardar
					</Button>{' '}
					<Button color="secondary" onClick={handleClose}><i className='fa fa-times'></i> Cancelar</Button>
				</ModalFooter>
	        </Modal>
		</div>
	);
}

export default AddObservation;